import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Game Selection
      "selectGame": "Select Game",
      "gameSelect": "Game Selection",
      "individual": "Individual",
      "team": "Team",
      "group": "Group",
      
      // Players
      "playerA": "Player A",
      "playerB": "Player B",
      "playerName": "Player Name",
      "teamName": "Team Name",
      
      // Game Controls
      "start": "Start",
      "pause": "Pause",
      "resume": "Resume",
      "reset": "Reset",
      "finish": "Finish",
      
      // Scores
      "score": "Score",
      "gamePoint": "Game Point",
      "matchPoint": "Match Point",
      "set": "Set",
      "game": "Game",
      
      // Common
      "close": "Close",
      "save": "Save",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "back": "Back",
      "next": "Next",
      
      // Colors
      "shirtColor": "Shirt Color",
      "selectColor": "Select Color",
      
      // Setup
      "setup": "Setup",
      "settings": "Settings",
      "configuration": "Configuration",
      
      // Language
      "language": "Language",
      "selectLanguage": "Select Language",
      "english": "English",
      "spanish": "Spanish",
      
      // Game Types
      "singles": "Singles",
      "individualCompetitions": "Individual Competitions",
      "teamResult": "Team Result",
      "double": "Double",
      "doubleDescription": "Double Competition",
      "olympicTeamFormat": "Olympic Team Format",
      "worldCup": "World Cup",
      "worldCupFormat": "World Cup Format",
      "twoPeopleTeamWithDoubles": "2 People Team with Doubles",
      "twoPeopleTeamWithDoublesDescription": "Doubles in 3rd Match",
      "swaythlingWithoutDoubles": "Swaythling Without Doubles",
      "swaythlingWithoutDoublesSpanishSuper": "Spanish Super Format",
      "swaythlingWithDoubles4th": "Swaythling With Doubles (4)",
      "swaythlingWithDoubles4thMatch": "Doubles in 4th Match",
      "swaythlingWithDoubles7th": "Swaythling With Doubles (7)",
      "swaythlingWithDoubles7thSpanishHonor": "Spanish Honor Format",
      "modifiedSwaythling": "Modified Swaythling",
      "modifiedSwaythlingFormat": "Modified Swaythling Format",
      
      // Group Setup
      "teamABC": "Team ABC",
      "teamXYZ": "Team XYZ",
      "competitionStage": "Competition Stage",
      "missingPlayer": "Missing player",
      "nameForTeamABCMissing": "Name for Team ABC is missing",
      "nameForTeamXYZMissing": "Name for Team XYZ is missing",
      
      // Group Ongoing
      "confirmResult": "Confirm the result",
      "yes": "Yes",
      "no": "No",
      "doublesPlayers": "Doubles Players",
      "players": "Players", 
      "deleteResultGameSet": "Delete the result of Game {{game}} Set {{set}}",
      "changeCurrentResult": "Change the current result: {{result}}",
      "vs": "VS",
      "name": "Name",
      "total": "Total",
      "final": "Final",
      "continue": "Continue",
      "configureDoubles": "Configure Doubles",
      "changePlayers": "Change Players",
      "edit": "Edit",
      "autoPilotOn": "AutoPilot-On",
      "autoPilotOff": "AutoPilot-Off",
      "startGameIn": "Start Game In",
      "startNow": "Start Now",
      "playerConfiguration": "Choose player position and serve order",
      "clickOnPlayersToSelectServe": "Click on players to select who serves first",
      "clickToSelectServer": "Click to select server",
      "tshirtColor": "T-Shirt Color",
      
      // Game Numbers
      "game1": "G1",
      "game2": "G2", 
      "game3": "G3",
      "game4": "G4",
      "game5": "G5",
      
      // GameOngoing
      "timeoutTitle": "Time Out",
      "left": "Left",
      "right": "Right",
      "finalButton": "FINAL",
      "swap": "Swap",
      "expedite": "Expedite",
      "switchTableSide": "Switch the table side",
      "expediteModeActivated": "Expedite Mode Activated",
      "expediteModeDisabled": "Expedite Mode Disabled",
      "unSynced": "UnSynced",
      "synced": "Synced",
      "pilotOn": "Pilot-On",
      "pilotOff": "Pilot-Off",
      
      // GameState
      "selectWhoServeFirst": "Select who serve first",
      "timeout": "Timeout",
      "counterTimeout": "Timeout",
      "cards": "Cards"
    }
  },
  es: {
    translation: {
      // Game Selection
      "selectGame": "Seleccionar Juego",
      "gameSelect": "Selección de Juego",
      "individual": "Individual",
      "team": "Equipo",
      "group": "Grupo",
      
      // Players
      "playerA": "Jugador A",
      "playerB": "Jugador B",
      "playerName": "Nombre del Jugador",
      "teamName": "Nombre del Equipo",
      
      // Game Controls
      "start": "Iniciar",
      "pause": "Pausar",
      "resume": "Reanudar",
      "reset": "Reiniciar",
      "finish": "Finalizar",
      
      // Scores
      "score": "Puntuación",
      "gamePoint": "Punto de Juego",
      "matchPoint": "Punto de Partido",
      "set": "Set",
      "game": "Juego",
      
      // Common
      "close": "Cerrar",
      "save": "Guardar",
      "cancel": "Cancelar",
      "confirm": "Confirmar",
      "back": "Atrás",
      "next": "Siguiente",
      
      // Colors
      "shirtColor": "Color de Camisa",
      "selectColor": "Seleccionar Color",
      
      // Setup
      "setup": "Configuración",
      "settings": "Ajustes",
      "configuration": "Configuración",
      
      // Language
      "language": "Idioma",
      "selectLanguage": "Seleccionar Idioma",
      "english": "Inglés",
      "spanish": "Español",
      
      // Game Types
      "singles": "Individuales",
      "individualCompetitions": "Competiciones Individuales",
      "teamResult": "RESULTADO DE EQUIPO",
      "double": "Dobles",
      "doubleDescription": "Competición de Dobles",
      "olympicTeamFormat": "DE EQUIPO OLÍMPICO",
      "worldCup": "COPA DEL MUNDO",
      "worldCupFormat": "Formato Copa del Mundo",
      "twoPeopleTeamWithDoubles": "EQUIPO DE 2 PERSONAS",
      "twoPeopleTeamWithDoublesDescription": "Dobles en 3er Partido",
      "swaythlingWithoutDoubles": "Swaythling sin DOBLES",
      "swaythlingWithoutDoublesSpanishSuper": "Formato Super Español",
      "swaythlingWithDoubles4th": "Swaythling con DOBLES (4)",
      "swaythlingWithDoubles4thMatch": "Dobles en 4to Partido",
      "swaythlingWithDoubles7th": "Swaythling con DOBLES (7)",
      "swaythlingWithDoubles7thSpanishHonor": "Formato Honor Español",
      "modifiedSwaythling": "Swaythling Modificado",
      "modifiedSwaythlingFormat": "ETTU EuroCUP/Champions",
      "tshirtColor": "Color de Camiseta",
      
      // Group Setup
      "teamABC": "Equipo ABC",
      "teamXYZ": "Equipo XYZ",
      "competitionStage": "Etapa de Competición",
      "missingPlayer": "Falta jugador",
      "nameForTeamABCMissing": "Falta el nombre del Equipo ABC",
      "nameForTeamXYZMissing": "Falta el nombre del Equipo XYZ",
      
      // Group Ongoing
      "confirmResult": "Confirmar el resultado",
      "yes": "Sí",
      "no": "No",
      "doublesPlayers": "Jugadores de los Dobles",
      "players": "Jugadores",
      "deleteResultGameSet": "Eliminar el resultado del Juego {{game}} Set {{set}}",
      "changeCurrentResult": "Cambiar el resultado actual: {{result}}",
      "vs": "VS",
      "name": "Nombre",
      "total": "Total",
      "final": "Final",
      "continue": "Continuar",
      "configureDoubles": "Configurar Dobles",
      "changePlayers": "Cambiar Jugadores",
      "edit": "Editar",
      "autoPilotOn": "AutoPilot-On",
      "autoPilotOff": "AutoPilot-Off",
      "startGameIn": "Iniciar juego en",
      "startNow": "Iniciar Ahora",
      "playerConfiguration": "Elige la posición del jugador y el orden de saque",
      "clickOnPlayersToSelectServe": "Clic en los jugadores para seleccionar quien saca primero",
      "clickToSelectServer": "Clic si sirvo primero",
      
      // Game Numbers
      "game1": "J1",
      "game2": "J2",
      "game3": "J3", 
      "game4": "J4",
      "game5": "J5",
      
      // GameOngoing
      "timeoutTitle": "Tiempo Muerto",
      "left": "Izquierda",
      "right": "Derecha",
      "finalButton": "FINAL",
      "swap": "Intercambiar",
      "expedite": "Expedite",
      "switchTableSide": "Cambiar lado de la mesa",
      "expediteModeActivated": "Expedite Activado",
      "expediteModeDisabled": "Expedite Desactivado",
      "unSynced": "Sin Sincronizar",
      "synced": "Sincronizado",
      "pilotOn": "AutoPilot",
      "pilotOff": "AutoPilotOff",
      
      // GameState
      "selectWhoServeFirst": "Selecciona quién saca primero",
      "timeout": "Timeout",
      "counterTimeout": "Tiempo Expirado",
      "cards": "Tarjetas"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    
    react: {
      useSuspense: false,
    },
  });

export default i18n;